import { gameImageUrl, minimizeAimCursorUrl } from "./game-image-urls.js";

var IMG_BINDINGS = [
  [".hp-pill__cost img", "gem"],
  [".live-revive-overlay__revive-icon", "buttonAd"],
  ["#gemBadge img", "gem"],
  ["#shakeBtn img", "buttonShake"],
  ["#bombCellBtn > img", "buttonClear"],
  ["#bombTripleBtn > img", "buttonClear"],
  ["#minimizeBtn > img", "buttonShrink"],
  [".mockup-action__badge.cost img", "gem"],
  [".minimize-btn__cost img", "gem"],
];

/**
 * Apply bundled image URLs to static DOM nodes in index.html.
 */
export function applyDomAssetUrls() {
  if (typeof document === "undefined") return;

  for (var i = 0; i < IMG_BINDINGS.length; i++) {
    var selector = IMG_BINDINGS[i][0];
    var key = IMG_BINDINGS[i][1];
    var url = gameImageUrl(key);
    if (!url) continue;
    var nodes = document.querySelectorAll(selector);
    for (var n = 0; n < nodes.length; n++) {
      nodes[n].setAttribute("src", url);
    }
  }

  document.querySelectorAll("img[data-game-img]").forEach(function (img) {
    var key = img.getAttribute("data-game-img");
    var url = gameImageUrl(key);
    if (url) img.setAttribute("src", url);
  });

  var aimUrl = minimizeAimCursorUrl();
  if (aimUrl && document.documentElement && document.documentElement.style) {
    document.documentElement.style.setProperty(
      "--minimize-aim-cursor",
      'url("' + aimUrl + '") 16 16, crosshair',
    );
  }
}